// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BeforeAfterRouteImport } from './routes/before-after'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as GalleryAdminRouteImport } from './routes/gallery-admin'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BeforeAfterRoute = BeforeAfterRouteImport.update({
            id: '/before-after',path: '/before-after',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const GalleryAdminRoute = GalleryAdminRouteImport.update({
            id: '/gallery-admin',path: '/gallery-admin',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,BeforeAfterRoute: BeforeAfterRoute,ContactRoute: ContactRoute,GalleryRoute: GalleryRoute,GalleryAdminRoute: GalleryAdminRoute,ServicesRoute: ServicesRoute,UnsubscribeRoute: UnsubscribeRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)